import React from "react";
import Skeleton from "./Skeleton";

const DynamicFormLoader = () => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        {Array.from({ length: 2 }, (_, i) => (
          <div
            key={i}
            className="h-10 bg-slate-50 border border-gray-100 rounded-md flex items-center justify-center"
          >
            <div className="w-full h-3 px-3">
              <Skeleton height={"100%"} width={"100%"} />
            </div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-3 gap-4">
        {Array.from({ length: 3 }, (_, i) => (
          <div
            key={i}
            className="h-10 bg-slate-50 border border-gray-100 rounded-md flex items-center justify-center"
          >
            <div className="w-full h-3 px-3">
              <Skeleton height={"100%"} width={"100%"} />
            </div>
          </div>
        ))}
      </div>
      <div className="h-10 bg-slate-50 border border-gray-100 rounded-md flex items-center justify-center">
        <div className="w-full h-3 px-3">
          <Skeleton height={"100%"} width={"100%"} />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        {Array.from({ length: 2 }, (_, i) => (
          <div
            key={i}
            className="h-10 bg-slate-50 border border-gray-100 rounded-md flex items-center justify-center"
          >
            <div className="w-full h-3 px-3">
              <Skeleton height={"100%"} width={"100%"} />
            </div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-2 gap-4">
        {Array.from({ length: 2 }, (_, i) => (
          <div
            key={i}
            className="h-10 bg-slate-50 border border-gray-100 rounded-md flex items-center justify-center"
          >
            <div className="w-full h-3 px-3">
              <Skeleton height={"100%"} width={"100%"} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DynamicFormLoader;
